import { useState, useMemo } from 'react';
import { useBoolean } from '@entegral/helpers.react/hooks/boolean';
import { useBaseFilters } from './base';
import { useQueryFilters } from './query';
import { useFiltersInited } from './inited';
import { useStatusFilter } from './specific/status';
import { usePriceFilters } from './specific/price';
import { useBedroomFilter } from './specific/bedroom';
import { useBathroomFilter } from './specific/bathroom';
import { useGarageFilter } from './specific/garage';
import { useParkingFilter } from './specific/parking';
import { useFloorSizeFilter } from './specific/floor-size';
import { useMaxFloorSizeFilter } from './specific/max-floor-size';
import { useLandSizeFilter } from './specific/land-size';
import { useTypeFilter } from './specific/type';
import { usePoolFilter } from './specific/pool';
import { usePetsFilter } from './specific/pets';
import { useFlatletFilter } from './specific/flatlet';
import { useStaffRoomsFilter } from './specific/staff-rooms';
import { useDevelopmentFilter } from './specific/development';
import { useOnShowFilter } from './specific/on-show';
import { useReducedFilter } from './specific/reduced';
import { useFurnishedFilter } from './specific/furnished';
import { useFeaturesFilter } from './specific/features';
import { useAreasFilter } from './specific/areas';

export function useFilters(config) {
  let [ isOpened, open, close ] = useBoolean(false);

  let baseFilters = useBaseFilters(config);
  let [ filters, setFilters ] = useState(baseFilters);
  let { query, updateQuery } = useQueryFilters();

  let { status, statusOptions, onStatusSelect } = useStatusFilter({ config, query, setFilters, updateQuery });
  let { areas, areaQuery, areaMatches, onAreaQueryChange, onAreaSelect, onAreaRemove } = useAreasFilter({ config, query, setFilters, updateQuery });
  let { priceMin, priceMinOptions, onPriceMinSelect, priceMax, priceMaxOptions, onPriceMaxSelect } = usePriceFilters({ config, query, setFilters, updateQuery, status });
  let { bedroom, bedroomOptions, onBedroomSelect } = useBedroomFilter({ config, query, setFilters, updateQuery });
  let { bathroom, bathroomOptions, onBathroomSelect } = useBathroomFilter({ config, query, setFilters, updateQuery });
  let { garage, garageOptions, onGarageSelect } = useGarageFilter({ config, query, setFilters, updateQuery });
  let { parking, parkingOptions, onParkingSelect } = useParkingFilter({ config, query, setFilters, updateQuery });
  let { floorSize, floorSizeOptions, onFloorSizeSelect } = useFloorSizeFilter({ config, query, setFilters, updateQuery });
  let { maxFloorSize, maxFloorSizeOptions, onMaxFloorSizeSelect } = useMaxFloorSizeFilter({ config, query, setFilters, updateQuery });
  let { landSize, landSizeOptions, onLandSizeSelect } = useLandSizeFilter({ config, query, setFilters, updateQuery });
  let { types, typeOptions, typeCaptionFormatter, onTypeToggle } = useTypeFilter({ config, query, setFilters, updateQuery, status });
  let { pool, onPoolChange } = usePoolFilter({ config, query, setFilters, updateQuery });
  let { pets, onPetsChange } = usePetsFilter({ config, query, setFilters, updateQuery });
  let { flatlet, onFlatletChange } = useFlatletFilter({ config, query, setFilters, updateQuery });
  let { staffRooms, onStaffRoomsChange } = useStaffRoomsFilter({ config, query, setFilters, updateQuery });
  let { development, onDevelopmentChange } = useDevelopmentFilter({ config, query, setFilters, updateQuery });
  let { onShow, onOnShowChange } = useOnShowFilter({ config, query, setFilters, updateQuery });
  let { reduced, onReducedChange } = useReducedFilter({ config, query, setFilters, updateQuery });
  let { furnished, onFurnishedChange } = useFurnishedFilter({ config, query, setFilters, updateQuery });
  let { features, featuresOptions, onFeatureToggle, onFeatureChange } = useFeaturesFilter({ config, query, setFilters, updateQuery });

  let isInited = useFiltersInited({ config, filters });

  return {
    baseFilters,
    filters,
    query,

    isOpened,
    isInited,
    open,
    close,

    status,
    statusOptions,
    onStatusSelect,

    areas,
    areaQuery,
    areaMatches,
    onAreaQueryChange,
    onAreaSelect,
    onAreaRemove,

    types,
    typeOptions,
    typeCaptionFormatter,
    onTypeToggle,

    priceMin,
    priceMinOptions,
    onPriceMinSelect,

    priceMax,
    priceMaxOptions,
    onPriceMaxSelect,

    bedroom,
    bedroomOptions,
    onBedroomSelect,

    bathroom,
    bathroomOptions,
    onBathroomSelect,

    garage,
    garageOptions,
    onGarageSelect,

    parking,
    parkingOptions,
    onParkingSelect,

    floorSize,
    floorSizeOptions,
    onFloorSizeSelect,

    maxFloorSize,
    maxFloorSizeOptions,
    onMaxFloorSizeSelect,

    landSize,
    landSizeOptions,
    onLandSizeSelect,

    pool,
    onPoolChange,

    pets,
    onPetsChange,

    flatlet,
    onFlatletChange,

    staffRooms,
    onStaffRoomsChange,

    development,
    onDevelopmentChange,

    onShow,
    onOnShowChange,

    reduced,
    onReducedChange,

    furnished,
    onFurnishedChange,

    features,
    featuresOptions,
    onFeatureToggle,
    onFeatureChange,
  };
}



